import { Dispatch, SetStateAction } from "react";
import { Box } from "@mui/material";
import DXButton from "features/common/components/DXButton";
import DXModal from "features/common/components/DXModal/DXModal";
import DXInputField from "features/common/components/DXInputField";

export interface DeleteAccountProps {
  isOpenModalDelete: boolean;
  setIsOpenModalDelete?: Dispatch<SetStateAction<boolean>>;
  handleDelete?: (companyId: string) => void;
  handleChange?: (value: string) => void;
  id?: string;
  text: string;
  confirmLabel: string;
  title: string;
  complementaryText?: string;
  disabled?: boolean;
  isDeleteCompany?: boolean;
}

export const ModalDeleteCompany = ({
  setIsOpenModalDelete,
  isOpenModalDelete,
  handleDelete,
  id,
  text,
  complementaryText,
  confirmLabel,
  title,
  handleChange,
  disabled,
  isDeleteCompany
}: DeleteAccountProps) => {
  return (
    <DXModal
      title={title}
      open={isOpenModalDelete}
      onClose={() => setIsOpenModalDelete(false)}
      customWidth={438}
      children={
        <>
          <Box sx={{
            textAlign: "justify",
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: '22px',
            marginBottom: '16px'
          }}>{text}</Box>
          <Box sx={{
            textAlign: "justify",
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: '24px',
            marginBottom: '32px'
          }}>{complementaryText}
          </Box>
          {isDeleteCompany && (
            <>
             <Box sx={{
              textAlign: "justify",
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: '20px'
            }}>Confirm delete by typing DELETE ACCOUNT
            </Box>
            <Box>
              <DXInputField
                fullWidth
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleChange(event.target.value)}
              >
              </DXInputField>
            </Box>
            </>
          )}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              paddingTop: 4,
              marginBottom: '8px'
            }}
          >
            <DXButton
              color="secondary"
              variant="contained"
              sx={{ minWidth: "140px" }}
              onClick={() => setIsOpenModalDelete(false)}
            >
              Cancel
            </DXButton>
            <DXButton
              variant="contained"
              sx={{
                minWidth: "140px",
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.5 : 1
              }}
              onClick={() => !disabled && handleDelete && handleDelete(id)}
              color="error"
            >
              {confirmLabel}
            </DXButton>
          </Box>
        </>
      }
    />
  );
};
